import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
// import { getbase64 } from '@/utils/base64Converter';
import { useFormik } from 'formik';
import { InfinitySpin } from 'react-loader-spinner';
import { EditMacueDetail } from '../../../redux/admin/macue/macue_services_sync';

const baseSchema = Yup.object({
  title: Yup.string().required(),
});

const Edit_Macue = () => {
  const dispatch = useDispatch();

  const { mcuEditLoader, macueDetails } = useSelector((state) => state.macue);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (mcuEditLoader) return;

    const payload = {
      ...value,
    };

    await dispatch(EditMacueDetail({ ...macueDetails, ...payload }));

    resetForm();
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  useEffect(() => {
    setFieldValue('title', macueDetails?.title);
  }, [macueDetails]);

  return (
    <>
      <div class="row">
        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">General Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-0">
                    <label for="description" class="form-label">
                      Title
                    </label>
                    <textarea
                      class="form-control bg-light-subtle"
                      id="description"
                      rows="7"
                      placeholder="Type title"
                      value={values.title || ''}
                      onChange={handleChange}
                      name="title"
                      style={{
                        border: errors.title && '1px solid red',
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              {/* <div class="col-lg-2">
                <a href="#!" class="btn btn-outline-secondary w-100">
                  Save Change
                </a>
              </div> */}
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {mcuEditLoader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Update Macue</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit_Macue;
